import React from 'react'

type RefreshCcwIconProps = {
  width?: number | string
  height?: number | string
  className?: string
  color?: string
}

export const RefreshCcwIcon = ({ width = 20, height = 20, className, color = 'currentColor' }: RefreshCcwIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M5.83333 8.33333H0.833333V3.33333M0.833333 8.33333L4.7 4.7C5.59562 3.80393 6.70364 3.14934 7.92067 2.79731C9.1377 2.44528 10.4241 2.40729 11.6598 2.68688C12.8954 2.96647 14.0402 3.55453 14.9871 4.39618C15.9341 5.23784 16.6524 6.30565 17.075 7.5M14.1667 11.6667H19.1667V16.6667M19.1667 11.6667L15.3 15.3C14.4044 16.1961 13.2964 16.8507 12.0793 17.2027C10.8623 17.5547 9.57592 17.5927 8.34024 17.3131C7.10455 17.0335 5.95983 16.4455 5.01289 15.6038C4.06594 14.7622 3.34764 13.6943 2.925 12.5"
      stroke={color}
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
